module.exports = __webpack_public_path__ + "images/98baff2b306bdfd718aa18e2c965d742-staying-pic-arunachal.png";